/*
* import the lang file
* */
import lang_sample from "@/pages/lang-demo/lang";
import home_sample from "@/pages/home/lang";

export default {
    lang_sample,
    home_sample
}